/* ©2018 EdgeVerve Systems Limited (a fully owned Infosys subsidiary),
Bangalore, India. All Rights Reserved.
*/
import { html, PolymerElement } from "../../@polymer/polymer/polymer-element.js";

/**
 * This polymer element is used for sliding transition in mobile devices while navigating from one page to other.
 * @customElement
 * @polymer
 * @summary Technical component
*/
class slideInOutTransition extends PolymerElement {
  static get template() {
    return html`
        <style is="" include="app-styles">
        @media (max-width: 479px) {
            .wrapper{}
        .animate-left{ position: relative; animation: animateleft 0.8s; @apply --animate-left-value; }
        @keyframes animateleft{ from{ right: 0; opacity: 0 } to{ right: -100%; opacity: 1 } }
        .animate-right{ position: relative; animation: animateright 0.8s;
        @apply --animate-right-value; } 
        @keyframes animateright{ from{ right: -100%; opacity: 0 } to{ right: 0; opacity: 1 } }
        }
        </style>
        <div class="wrapper">
        <div class="slide-content">
            <slot></slot>
        </div>
        </div>
         `;
  }

  static get properties() {
    return {
      /*Property to animate left side*/
      animateLeft: {
        type: Boolean,
        notify: true,
        observer: "_InvokeAnimateLeft"
      },
      /*Property to animate left side*/
      animateRight: {
        type: Boolean,
        notify: true,
        observer: "_InvokeAnimateRight"
      },
      /*Property to check when user swiped left */
      swipedLeft: {
        type: Boolean,
        notify: true,
      }

    };
  }
  /** 
   * Method to execute when animation needs to move rightwards
  **/
  _InvokeAnimateRight() {
    this._removeSlideAnimation();
    this._addSwipeDectorEvents();
    this.shadowRoot.querySelector('.slide-content').classList.add("animate-right");
    if (document.getElementById("mainContainer"))
      document.getElementById("mainContainer").classList.add("animate-right");
    setTimeout(this._removeSlideAnimation.bind(this), 800);
  }
  /** 
   * Method to execute when animation needs to move leftwards
  **/
  _InvokeAnimateLeft() {
    this._removeSlideAnimation();
    this.shadowRoot.querySelector('.slide-content').classList.add("animate-left");
    if (document.getElementById("mainContainer"))
      document.getElementById("mainContainer").classList.add("animate-left");
    setTimeout(this._removeSlideAnimation.bind(this), 800);
  }

  /** 
   * Method to execute when animation is completed to remove the unwanted classes
  **/
  _removeSlideAnimation() {
    this.shadowRoot.querySelector('.slide-content').classList.remove("animate-right", "animate-left");
    if (document.getElementById("mainContainer"))
      document.getElementById("mainContainer").classList.remove("animate-left", "animate-right");
  }
  /** 
   * Method to identify and trigger swiper actions
  **/
  _addSwipeDectorEvents() {
    let touchstartX = 0;
    let touchendX = 0;
    const slider = this.shadowRoot.querySelector('.slide-content');
    var self = this;
    function handleSwipe(startLimit, swipeRange) {
      if ((touchstartX < startLimit) && (touchendX - touchstartX) > swipeRange) {
        self.swipedLeft = !self.swipedLeft;
      }
    }
    slider.addEventListener('touchstart', e => {
      touchstartX = e.changedTouches[0].clientX;
    });
    slider.addEventListener('touchend', e => {
      touchendX = e.changedTouches[0].clientX;
	  var startLimit = window.innerWidth * .10;
      var swipeRange = 40;
      handleSwipe(startLimit, swipeRange);
    });
  }

}

window.customElements.define('slide-in-out-transition', slideInOutTransition);
